<!--
// app/components/pages/region-stats/ButtonSelectTypeStats.vue
-->
<script setup lang="ts">
import nuxtLink from "#app/components/nuxt-link";

type Props = {
  dataType: string;
  page: string | undefined;
};
defineProps<Props>();

const route = useRoute();
const localePath = useLocalePath();

const toQueries = (name: string) => {
  const queries = route.query;
  return {
    name,
    params: { region: route.params.region },
    query: queries,
  };
};
</script>

<template>
  <div class="selector-container">
    <component
      :is="dataType === 'players' ? 'button' : nuxtLink"
      :to="
        dataType === 'players'
          ? undefined
          : localePath(toQueries(page ? `region-stats-${page}` : 'region-stats'))
      "
      no-prefetch
      :class="['filter-stat-type rounded-s-lg', { selectedButton: dataType === 'players' }]"
    >
      <span class="block first-letter:capitalize whitespace-nowrap">{{
        $t("header.navCompetition.statsPlayers")
      }}</span>
    </component>
    <component
      :is="dataType === 'teams' ? 'button' : nuxtLink"
      :to="
        dataType === 'teams'
          ? undefined
          : localePath(toQueries(page ? `region-stats-teams-${page}` : 'region-stats-teams'))
      "
      no-prefetch
      :class="[
        'filter-stat-type border-s border-s-gray-800 rounded-e-lg',
        { selectedButton: dataType === 'teams' },
      ]"
    >
      <span class="block first-letter:capitalize">{{ $t("header.navCompetition.statsTeams") }}</span>
    </component>
  </div>
</template>

<style scoped>
.selector-container {
  @apply flex gap-0 overflow-hidden min-w-min;
}
.filter-stat-type {
  @apply bg-gray-900 text-gray-400 px-2 py-2 bigsm:px-4 text-[10px] bigsm:text-xs lg:text-sm flex justify-center;
  @apply min-w-[50%] items-center bigsm:px-6 bigsm:min-w-[150px] hover:bg-primary hover:text-black;
}

.selectedButton {
  @apply bg-primary text-black;
}
</style>
